import { startOfMonth, endOfMonth, eachDayOfInterval, getDay, getWeeksInMonth, startOfDay, isEqual, isAfter, setHours, setMinutes, setSeconds, isValid } from 'date-fns';
export const _getDate = (date) => {
    if (!date)
        return null;
    if (typeof date == "string") {
        date = new Date(date);
    }
    else {
        date = date;
    }
    return startOfDay(date);
};
export const getDatesOfMonth = (date) => {
    // get start date
    let stDate = startOfMonth(date);
    // end of the month
    let endDate = endOfMonth(date);
    // get start day index
    let stIndex = getDay(stDate);
    let endIndex = getDay(endDate);
    // get number of weeks 
    let numOfWeeks = getWeeksInMonth(stDate);
    // dates 
    let dates = eachDayOfInterval({ start: stDate, end: endDate });
    let updatedDates = [...Array(stIndex).fill(null), ...dates, ...Array(6 - endIndex).fill(null)];
    // group by weeks
    let weeks = [];
    for (let i = 0; i < numOfWeeks; i++) {
        while (updatedDates.length) {
            weeks.push(updatedDates.splice(0, 7));
        }
    }
    return weeks;
};
export const isDateDisabled = (date, disabledDates, isWeekendDisable, minDate, maxDate) => {
    if (!date)
        return true;
    if (isWeekendDisable && (getDay(date) == 0 || getDay(date) == 6))
        return true;
    // min date
    let _minDate = _getDate(minDate);
    if (_minDate && !isAfter(date, _minDate) && !isEqual(date, _minDate)) {
        return true;
    }
    let _maxDate = _getDate(maxDate);
    if (_maxDate && isAfter(date, _maxDate) && !isEqual(date, _maxDate)) {
        return true;
    }
    let inst = disabledDates === null || disabledDates === void 0 ? void 0 : disabledDates.find((d_date) => isEqual(date, d_date));
    return (inst != undefined);
};
export const isDateSelected = (date, selectedDates) => {
    if (!date)
        return false;
    let inst = selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.find((d_date) => isEqual(date, d_date));
    return (inst != undefined);
};
export const _getTimeDetails = (time, zeroSeconds) => {
    let _dateTime = new Date();
    if (time) {
        if (typeof time == "string") {
            // Full date/datetime strings (ISO 8601, "yyyy-mm-dd hh:mm:ss", "mm/dd/yyyy ...")
            // carry a date separator; bare time-of-day strings ("2:30 PM", "2300", "23:30")
            // never do. Parse the former as a real datetime — the time-only heuristics below
            // split on ':' and would read the year as the hour (e.g. "2026-07-07T14:.." would
            // set hours to 2026, discarding the date entirely).
            const parsed = /[-/]/.test(time) ? new Date(time) : null;
            if (parsed && isValid(parsed)) {
                _dateTime = parsed;
            }
            else {
                // Enhanced parsing for multiple formats (12pm, 1am, 23:30, 1:30, etc.)
                const timeStr = time.trim().toLowerCase();
                // Extract AM/PM (with or without space)
                const ampmMatch = timeStr.match(/(am|pm)$/i);
                const hasMeridiem = !!ampmMatch;
                const isEvening = (ampmMatch === null || ampmMatch === void 0 ? void 0 : ampmMatch[1]) === 'pm';
                // Remove AM/PM from string to get time part
                const timePart = hasMeridiem ? timeStr.replace(/(am|pm)$/i, '').trim() : timeStr;
                // Parse time components
                let _h = 0;
                let _m = 0;
                let _s = 0;
                // Check if it's military time format (digits only, 3-4 chars)
                if (/^\d{3,4}$/.test(timePart)) {
                    // Military time: 2300, 0130, 130, etc.
                    const digits = timePart;
                    if (digits.length === 4) {
                        // HHMM format (2300 → 23:00)
                        _h = parseInt(digits.substring(0, 2));
                        _m = parseInt(digits.substring(2, 4));
                    }
                    else if (digits.length === 3) {
                        // HMM format (130 → 1:30)
                        _h = parseInt(digits.substring(0, 1));
                        _m = parseInt(digits.substring(1, 3));
                    }
                }
                else {
                    // Standard format with colons (HH:MM:SS or HH:MM or HH)
                    const parts = timePart.split(':');
                    _h = parseInt(parts[0]) || 0;
                    _m = parseInt(parts[1]) || 0;
                    _s = parseInt(parts[2]) || 0;
                }
                // Handle 24-hour format and AM/PM conversion
                if (hasMeridiem) {
                    // User specified AM/PM
                    if (isEvening && _h < 12) {
                        _h += 12;
                    }
                    else if (!isEvening && _h === 12) {
                        _h = 0; // 12 AM = 00:00
                    }
                }
                else {
                    // No AM/PM specified
                    // If hour >= 13, it's 24-hour format (already correct)
                    // If hour = 12, assume noon (PM)
                    // If hour < 12, assume AM (no conversion needed)
                    // Hours 0-23 are treated as-is (24-hour format)
                }
                _dateTime = setHours(_dateTime, _h);
                _dateTime = setMinutes(_dateTime, _m);
                _dateTime = setSeconds(_dateTime, _s);
            }
        }
        else {
            _dateTime = time;
        }
    }
    else {
        _dateTime = setHours(_dateTime, 0);
        _dateTime = setMinutes(_dateTime, 0);
        _dateTime = setSeconds(_dateTime, 0);
    }
    let H = _dateTime.getHours();
    let M = _dateTime.getMinutes();
    let S = _dateTime.getSeconds();
    let isEvening = H >= 12;
    // Convert to 12-hour format for display
    let displayH = H;
    if (displayH > 12)
        displayH -= 12;
    if (displayH == 0)
        displayH = 12;
    if (zeroSeconds)
        S = 0;
    let str = prependZeros(displayH).concat(":", prependZeros(M), ":", prependZeros(S), isEvening ? " PM" : " AM");
    return {
        hours: displayH,
        mins: M,
        secs: S,
        evening: isEvening,
        date: _dateTime,
        timeString: str
    };
};
// prepend zeros
export const prependZeros = (val) => {
    return "00".substring(0, (2 - (val === null || val === void 0 ? void 0 : val.toString().length))) + val;
};
